// extracted by mini-css-extract-plugin
export default {"wrapper":"WithPadding_wrapper__PpPRu"};